'use strict';

var _ = require('lodash');
var angular = require('angular');
var DataExtractNewExtractPanelDirective = function DataExtractNewExtractPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/data-extract-new-extract.html'),
    controller: 'DataExtractNewExtractController',
    scope: {
      editedSchedule: '=?',
      registeredExtractNames: '=?'
    },
    link: function link($scope) {
      $scope.$on('listbox-item:dblclicked', $scope.onListBoxItemDblClicked);
      $scope.$watch('extractConfig.level', function () {
        if ($scope.extractConfig.level) {
          var fields = $scope.extractConfig.level.fields;
          $scope.extractConfig.filterableFields = _.filter(fields, function (d) {
            return d.availableFilters.length > 0;
          });
        }
      });
    }
  };
};
DataExtractNewExtractPanelDirective.$inject = [];
module.exports = DataExtractNewExtractPanelDirective;